<template>
  <div>
    <vue-advanced-chat
        ref="chatWindow"
        :height="isAndroid ? 'calc(100vh)' : 'calc(100vh - 55px)'"
        :current-user-id="myUser"
        :room-id="roomId"
        :load-first-room="'false'"
        :rooms="JSON.stringify(loadedRooms)"
        :loading-rooms="JSON.stringify(loadingRooms)"
        :rooms-loaded="JSON.stringify(roomsLoaded)"
        :messages="JSON.stringify(messages)"
        :messages-loaded="messagesLoaded"
        :menu-actions="JSON.stringify(menuActionForRoom)"
        :message-selection-actions="JSON.stringify(messageSelectionActions)"
        :text-messages="JSON.stringify(textMessages)"
        :show-audio="'false'"
        :media-preview-enabled="'false'"
        :message-actions="JSON.stringify(messageActionsForRoom)"
        :show-reaction-emojis="'false'"
        :show-emojis="'false'"
        :show-new-messages-divider="'false'"
        :styles="JSON.stringify(styles)"
        :username-options="JSON.stringify({minUsers: 3, currentUser: false})"
        @fetch-more-rooms="fetchMoreRooms"
        @fetch-messages="fetchMessages($event.detail[0])"
        @add-room="onShowCreateRoom"
        @send-message="sendMessage($event.detail[0])"
        @menu-action-handler="handleRoomAction($event.detail[0])"
        @open-file="onOpenFile($event.detail[0])"
        @message-selection-action-handler="messageSelected($event.detail[0])"
        @message-action-handler="messageAction($event.detail[0])"
        @send-message-reaction="prioHandler($event.detail[0])"
    >
      <div slot="spinner-icon-infinite-rooms">
        <div id="vac-circle" v-if="loadingRooms"></div>
      </div>
      <!--div v-for="(message, index) in messages" :slot="'message-avatar_' + message._id"
           :class="[message.senderId !== myUser ? 'chat-avatar' : 'chat-avatar mine']" class="chat-avatar" v-if="index === 0 || messages[index-1].senderId !== message.senderId">
        {{getFistCharacter(message.username)}}
      </div-->
    </vue-advanced-chat>
    <b-modal size="lg" v-model="showModalMap" id="modal-map" centered
             body-class="my-body" hide-footer hide-header>
      <b-row style="margin-bottom: 0">
        <b-col style="height: 450px; padding: 0; margin-bottom: 0" id="map_container"
               ref="map_container">
        </b-col>
      </b-row>
    </b-modal>
    <b-modal size="sm" v-model="showGroup" centered title="Gruppenmitglieder"
    >
      <b-row class="mt-2">
        <b-col>
            <div v-for="item in roomUsers" :key="item" style="padding: 4px;">
              {{ item }}
            </div>
        </b-col>
      </b-row>
      <template #modal-footer="{ok}">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="md" variant="primary" @click="showGroup = false">
          Ok
        </b-button>
      </template>
    </b-modal>
    <media-preview v-if="showPreview" @close-media-preview="hidePreview" :file="previewFile"></media-preview>
    <b-modal size="md" v-model="showInviteUser" centered title="Nutzer hinzufügen"
    >
      <b-row class="mt-2">
        <b-col>
          <span>Mitarbeiter auswählen</span>
          <v-jstree ref="js_tree_2" :allow-transition="false"
                    style="flex: 1 0; border: 1px solid #c0c0c0; border-radius: 0.25rem; margin-top: 0.75rem"
                    class="my-tree" :data="possibleInvites"
                    @item-click="onInviteItemClicked"
                    show-checkbox
                    :multiple="false"
                    :allow-batch="false"></v-jstree>
        </b-col>
      </b-row>
      <template #modal-footer="{ok, cancel}">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="md" variant="primary" @click="showInviteUser = false">
          Abbrechen
        </b-button>
        <b-button size="md" :disabled="selectedInvite === null" variant="success" @click="onInvite">
          Hinzufügen
        </b-button>
      </template>
    </b-modal>
    <structure-list ref="create_chat_modal" id="create_chat_modal" :bauhof-structure="possibleUser" :multi-select="true" @on-selected="onCreateRoom"/>
    <structure-list ref="share_modal" id="share_modal" :bauhof-structure="possibleUser" :multi-select="true" :is-normal-share="true" @on-selected="onShareMessages"/>
    <structure-list ref="invite_modal" id="invite_modal" :bauhof-structure="possibleInvites" :multi-select="false" @on-selected="onInvite"/>
  </div>
</template>

<script>

import * as firestoreService from '@/shared/firebase/database'
import {register} from 'vue-advanced-chat'
import {isImageFile, Redirect_500, Redirect_Login, Server_URL} from "../../shared/utils";
import VJstree from "vue-jstree";
import MediaPreview from "../messaging/util/MediaPreview.vue"
import StructureList from "@/views/lists/StructureList.vue";
import {
  decryptAES,
  decryptChatMessages,
  decryptFile,
  decryptRooms,
  encryptAES,
  encryptEntry,
  encryptFile,
    arrayBufferToBase64
} from "@/shared/crypto";
import {formatTimestamp, parseTimestamp} from "@/shared/dates";
import {v4, v4 as uuidv4} from 'uuid';
import {updateLastRead} from "@/shared/firebase/database";
import ZoomControl from 'mapbox-gl-controls/lib/zoom';
import LanguageControl from 'mapbox-gl-controls/lib/language';
import mapboxgl from 'mapbox-gl/dist/mapbox-gl';
const messageRefreshRate = 1000;
register()
export default {
  name: "messaging",
  components: {
    VJstree,
    MediaPreview,
    StructureList
  },
  data() {
    return {
      styles: {
        message: {
          background: '#fff',
          backgroundMe: '#e8eff8',
        }
      },
      isAndroid: false,
      isBauhof: false,
      // util
      loader: undefined,
      // file preview
      previewFile: null,
      showPreview: false,
      // show room users
      showGroup: false,
      roomUsers: [],
      // create room
      showCreateRoom: false,
      possibleUser: [],
      selectedUser: [],
      selectedUserNames: [],
      roomName: "",
      currentNewId: '',
      // chat config
      myUser: "",
      roomsPerPage: 20,
      rooms: [],
      roomId: '',
      roomsLoaded: false,
      loadingRooms: true,
      roomsLoadedCount: 0,
      selectedRoom: null,
      messagesPerPage: 20,
      messages: [],
      messagesLoaded: false,
      menuActions: [
        {name: 'showUsers', title: 'Gruppenmitglieder anzeigen'},
        {name: 'gotoTask', title: 'Zur Aufgabe'},
        {name: 'inviteUser', title: 'Nutzer hinzufügen'},
        {name: 'leaveChat', title: 'Aus dem Chat austreten'},
      ],
      messageSelectionActions: [{name: 'newTask', title: 'Neue Aufgabe anlegen'}, {name: 'share', title: 'Weiterleiten'}],
      messageActions: [
        {
          name: 'selectMessages',
          title: 'Markieren'
        },
        {
          name: 'newTaskFromMessage',
          title: 'Neue Aufgabe anlegen'
        },
        {
          name: 'sendAsTask',
          title: 'Als Kurzaufgabe senden',
          onlyMe: true
        },
        {
          name: 'share',
          title: 'Weiterleiten',
        },
        /*{
          name: 'setMessagePriority',
          title: 'Als Priorität versenden',
          onlyMe: true
        },*/
      ],
      textMessages: {
        ROOMS_EMPTY: 'Sie haben noch keine Chats.',
        ROOM_EMPTY: 'Kein Chat geöffnet',
        NEW_MESSAGES: 'Neue Nachrichten',
        MESSAGE_DELETED: 'Nachricht geloescht',
        MESSAGES_EMPTY: 'Keine Nachrichten im Chat',
        SEARCH: 'Suchen',
        CANCEL_SELECT_MESSAGE: 'Selektion beenden',
        TYPE_MESSAGE: 'Nachricht schreiben',
        CONVERSATION_STARTED: 'Beginn der Konversation: ',
      },
      // timers
      currentUserId: "",
      customerNumber: "",
      lastLoadedMessage: null,
      latestLoadedMessage: null,
      messageListeners: [],
      roomListeners: [],
      fetchedOnce: false,
      lastActive: null,
      participants: [],
      // invite users
      showInviteUser: false,
      possibleInvites: [],
      selectedInvite: null,

      testModal: false,
      showModalMap: false,

      initRoom: null,

      shareRoomId: '',
      shareMessages: [],
    }
  },
  beforeDestroy() {
    this.messageListeners.forEach(listener => listener())
    this.messageListeners = []
    this.roomListeners.forEach(listener => listener())
    this.roomListeners = []
    this.$refs.chatWindow.shadowRoot.removeEventListener("click", this.preventNav);
  },
  computed: {
    lastLoadedRoom() {
      if (this.rooms.length) {
        let index = Number.MAX_SAFE_INTEGER;
        let doc = null;
        for (let i = 0; i < this.rooms.length; i++) {
          if (this.rooms[i].index < index) {
            doc = this.rooms[i].doc;
            index = this.rooms[i].index;
          }
        }
        return doc;
      } else {
        return null;
      }
    },
    messageActionsForRoom() {
      for (let i = 0; i < this.rooms.length; i++) {
        if (this.rooms[i].roomId === this.selectedRoom) {
          let r = this.rooms[i];
          let res = [];
          res.push(this.messageActions[0]);
          res.push(this.messageActions[3]);
          res.push(this.messageActions[1]);
          if (r.room_type === "chat") {
            let allBh = true;
            for (let j = 0; j < r.users.length; j++) {
              if (r.users[j]._id !== 'dummy' && !/^\d{6}-\d{0,10}$/.test(r.users[j]._id)) {
                allBh = false;
                break;
              }
            }
            if (allBh) {
              res.push(this.messageActions[2]);
            }
          }
          return res;
        }
      }
      return [];
    },
    menuActionForRoom() {
      for (let i = 0; i < this.rooms.length; i++) {
        if (this.rooms[i].roomId === this.selectedRoom) {
          let r = this.rooms[i];
          let res = [];
          res.push(this.menuActions[0]);
          if (r.room_type === "task") {
            res.push(this.menuActions[1]);
          }
          if (r.room_type !== "chat") {
            if (r.room_type !== "task_int") {
              res.push(this.menuActions[2]);
            }
            for (let j = 0; j < r.users.length; j++) {
              if (r.users[j]._id === this.myUser) {
                res.push(this.menuActions[3]);
                break;
              }
            }
          }
          return res;
          break;
        }
      }
      return [];
    },
    loadedRooms() {
      return this.rooms.slice(0, this.roomsLoadedCount)
    },
    canContinue() {
      if (this.selectedUser.length === 1) {
        return true;
      } else if (this.selectedUser.length > 1 && this.roomName !== "") {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
    //this.fetchRooms()
    //console.log(this.$refs.chatWindow.shadowRoot.)
    this.isAndroid = navigator.userAgent === "BisOfficeMobile";
    this.isBauhof = navigator.userAgent.startsWith("Windows - BisOffice");
    var sheet = new CSSStyleSheet();
    sheet.replaceSync( `.vac-message-wrapper .vac-message-container {
  width: 95% !important;
}


.vac-message-wrapper .vac-message-box{
  width: 100% !important;
  min-width: 100% !important;
}
.vac-avatar {
  background-color: #fff;
}
.vac-message-files-container .vac-file-wrapper .vac-file-container {
    width: auto !important;
    max-width: 150px !important;
  }
  .vac-message-files-container .vac-file-wrapper {
     margin: 0 auto;
  }
  #vac-icon-double-checkmark-seen {
     fill: #6d6def !important;
  }
  .vac-message-actions-wrapper .vac-menu-left {
      right: 15px !important;
   }
   .vac-message-wrapper .vac-card-system {
          max-width: 300px !important;
   }

   .vac-button-reaction span {
  display: none;
}

.vac-button-reaction {
      font-size: 15px !important;
}

.vac-message-wrapper .vac-offset-current {
  margin-left: 0px !important;
}`)
    this.$refs.chatWindow.shadowRoot.adoptedStyleSheets = [ sheet ]
    this.$refs.chatWindow.shadowRoot.addEventListener("click", this.preventNav)
    this.currentUserId = this.$cookies.get("ps_user_id");
    this.customerNumber = this.$cookies.get("ps_customer_number");
    this.myUser = this.currentUserId;
    this.showLoader()
    this.$http.get(
        Server_URL + '/auftragsbuch/messaging/init?room_id=' + (this.$route.query.room_id ? this.$route.query.room_id : "")
    ).then(this.handleDataInit, this.responseError)
  },
  methods: {

    showMapIfNeeded() {
      mapboxgl.accessToken = 'pk.eyJ1Ijoic3ZlbnBldGVyc2VuIiwiYSI6ImNqc3Z0YW82dDBhbDE0NXFpOGRzOXI4NWsifQ.Sq1nJiC3uKfA5yfYN8wR9w';
      this.map = new mapboxgl.Map({
        container: 'map_container',
        style: 'mapbox://styles/mapbox/outdoors-v11',
        center: [this.lon, this.lat],
        zoom: 18,
        minZoom: 5,
        maxPitch: 0,
        attributionControl: false
      });

      this.map.addControl(new ZoomControl(), 'bottom-right');
      const languageControl = new LanguageControl({
        language: 'de',
      });
      this.map.addControl(languageControl);

      this.map.addControl(new mapboxgl.AttributionControl(), "top-right");

      this.marker = null;
      this.geojson = {};
      this.map.on('load', this.mapLoad);
    },
    mapLoad() {
      setTimeout(() => {
        if (this.marker === null) {
          let el = document.createElement('div');
          el.className = 'marker';

          this.marker = new mapboxgl.Marker({
            element: el,
            anchor: 'center',
          })
              .setLngLat([this.lon, this.lat])
              .addTo(this.map);
        }
        this.map.resize();
      });
    },
    showMap(lat, lon) {
      this.showModalMap = true;
      this.lat = lat;
      this.lon = lon;
      this.$nextTick(() => {
        this.showMapIfNeeded();
      });
    },
    preventNav(event) {
      const { target } = event
      // handle only links that do not reference external resources
      if (target && target.href && target.href.includes("coordinates?lat=")) {

        event.preventDefault();
        let coords = target.href.split("coordinates?lat=")[1]
        coords = coords.split("&lon=")
        this.showMap(parseFloat(coords[0]), parseFloat(coords[1]))
      } else if (target && target.href && target.href.includes("tasks?task_id=")) {
        event.preventDefault();
        let taskId = target.href.split("tasks?task_id=")[1]
        this.$router.push("/auftraege/auftrag/" + taskId);
      }
    },
    prioHandler(data){
    },
    async onInvite({ids}) {
      let room = null;
      for (let i = 0; i < this.rooms.length; i++) {
        if (this.rooms[i].roomId === this.selectedRoom) {
          room = this.rooms[i]
          break
        }
      }
      let me = JSON.parse(sessionStorage.getItem(this.$cookies.get("ps_user_id")));
      let them = JSON.parse(sessionStorage.getItem(ids[0]));
      let messagePlain = me.full_name + " hat " + them.full_name + " hinzugefügt."
      let encryptedContent = await encryptAES(sessionStorage.getItem("aes"), messagePlain);

      let req = {
        user_name: me.full_name,
        room_id: this.selectedRoom,
        data_id: this.selectedRoom,
        user_id: ids[0],
        invite_message: encryptedContent,
        invite_message_plain: messagePlain,
      }
      let response;
      try {
        response = await this.$http.post(
            Server_URL + '/auftragsbuch/messaging/room/invite', req
        )
      } catch (e) {
        this.responseError(e)
        return
      }
      if (response.status !== 200) {
        window.location = Redirect_500;
        return
      }
    },
    onInviteItemClicked(node, item, e) {
      this.selectedInvite = item;
    },
    getFistCharacter(name) {
      return name.charAt(0).toUpperCase()
    },
    messageSelected({ roomId, action, messages }) {
      if (action.name === 'newTask') {
        let messageIds = [];
        for (let i = 0; i < messages.length; i++) {
          messageIds.push(messages[i]._id);
        }
        this.createTaskFromMessages(roomId, messageIds);
      } else if (action.name === 'share') {
        let messageIds = [];
        for (let i = 0; i < messages.length; i++) {
          messageIds.push(messages[i]._id);
        }
        this.shareMessageIds(roomId, messageIds);
      }
    },
    shareMessageIds(roomId, messageIds) {
      this.shareRoomId = roomId;
      this.shareMessages = messageIds;
      this.$refs.share_modal.showModal();
    },
    async messageAction({ roomId, action, message }) {
      if (action.name === 'newTaskFromMessage') {
        this.createTaskFromMessages(roomId, [message._id])
      } else if (action.name === 'sendAsTask') {
        if (message.message_type !== 'text') {
          this.$bvToast.toast("Nur Text-Nachrichten können so an die Tagesberichtserfassung gesendet werden.", {
            title: 'Achtung',
            autoHideDelay: 3000,
            appendToast: false,
            toaster: 'b-toaster-bottom-center',
          })
          return
        } else if (message.value_2 === 'tb') {
          this.$bvToast.toast("Die Nachricht ist bereits an die Tagesberichtserfassung gesendet worden.", {
            title: 'Achtung',
            autoHideDelay: 3000,
            appendToast: false,
            toaster: 'b-toaster-bottom-center',
          })
          return
        }
        let index = this.getRoomIndex(roomId);
        if (index === -1) {
          return;
        }
        let room = this.rooms[index]
        let recipient = "";
        for (let i = 0; i < room.users.length; i++) {
          if (room.users[i]._id !== 'dummy' && room.users[i]._id !== this.currentUserId) {
            recipient = room.users[i]._id;
            break
          }
        }
        let req = {
          recipient: recipient,
          gi_memo: await encryptAES(sessionStorage.getItem("aes"), message.content),
          gi_memo_plain: message.content,
        }
        this.showLoader();
        this.$http.post(
            Server_URL + '/auftragsbuch/data/create_int?room_id='+roomId+"&message_id="+message._id, req
        ).then(this.handleOkTrap, this.responseError)
      } else if (action.name === 'share') {
        this.shareMessageIds(roomId, [message._id])
      } else {
        if (message.message_type !== 'text') {
          this.$bvToast.toast("Nur Text-Nachrichten können als Priorität markiert werden.", {
            title: 'Achtung',
            autoHideDelay: 3000,
            appendToast: false,
            toaster: 'b-toaster-bottom-center',
          })
          return
        } else if (message.value_2 === 'prio') {
          this.$bvToast.toast("Die Nachricht ist bereits als Priorität markiert.", {
            title: 'Achtung',
            autoHideDelay: 3000,
            appendToast: false,
            toaster: 'b-toaster-bottom-center',
          })
          return
        }
        // fetch all user phone numbers from chat
        let index = this.getRoomIndex(roomId);
        if (index === -1) {
          return;
        }
        let room = this.rooms[index]
        let req = {
          message_id: message._id,
          room_id: roomId,
          message_plain: message.content,
          user_plain: message.username,
          recipients: {}
        }
        this.showLoader();
        for (let i = 0; i < room.users.length; i++) {
          let cur = room.users[i];
          if (cur._id !== 'dummy' && cur._id !== this.currentUserId) {
            let u = JSON.parse(sessionStorage.getItem(cur._id));
            if (u !== null) {
              let phone_number = u.mobile_number;
              let phone_number_backup = u.phone_number;
              if (phone_number === "" && phone_number_backup === "") {
                continue
              } else if (phone_number === "") {
                phone_number = phone_number_backup;
                phone_number_backup = ""
              }
              req.recipients[cur._id] = {
                phone_number: phone_number,
                phone_number_backup: phone_number_backup,
              }
            }
          }
        }
        this.$http.post(
            Server_URL + '/auftragsbuch/messaging/priority_message', req
        ).then(this.handleOkTrap, this.responseError)
      }
    },
    createTaskFromMessages(roomId, messageIds) {
      let dataId = uuidv4();
      sessionStorage.setItem(dataId, JSON.stringify({
        roomId: roomId,
        messages: messageIds
      }));
      this.$router.push("/create?message_payload=" + dataId);
    },
    hidePreview() {
      this.showPreview = false;
      URL.revokeObjectURL(this.previewFile.url);
    },
    async onOpenFile({ message, file }) {
      if (navigator.userAgent === "BisOfficeMobile") {
        Android.onLoadFile(file.file.server_url);
        return
      }
      this.showLoader();
      // get the file blob
      try {
        let response = await this.$http.get(
            file.file.server_url, {responseType: 'blob'}
        )
        let blobData = await response.blob();
        let dec = await decryptFile(sessionStorage.getItem("aes"), await blobData.arrayBuffer());
        this.hideLoader();
        if (this.isBauhof && file.action !== "preview") {
          try {
            windowsFileService.onFile(
              arrayBufferToBase64(dec),
              file.file.name,
              blobData.type
            ).then(r => {
              if (r && !r.Success) {
                console.log(r)
              }
            }).catch(e => {
              console.log(e)
            });
          } catch (e) {
            console.log(e);
          }
          return
        }
        const b =  new File([dec], file.file.name, {type: blobData.type});
        const blobUrl = URL.createObjectURL(b);
        if (file.action === "preview") {
          this.previewFile = {url: blobUrl}
          this.showPreview = true;
        } else {
          window.open(blobUrl, file.file.name);
          setTimeout(() => {
            URL.revokeObjectURL(blobUrl);
          }, 1000);
        }

      } catch (error) {
        console.log(error)
        //this.responseError(error)
      }
    },
    async handleRoomAction({ roomId, action }) {
      if (action.name === "showUsers") {
        this.showRoomUsers({ roomId, action });
      } else if (action.name === "gotoTask") {
        let room = null;
        for (let i = 0; i < this.rooms.length; i++) {
          if (this.rooms[i].roomId === roomId) {
            room = this.rooms[i];
            break
          }
        }
        if (!room) {
          return
        }
        this.$router.push("/auftraege/auftrag/" + room.roomId);
      } else if(action.name === "inviteUser") {
          let room = null;
        for (let i = 0; i < this.rooms.length; i++) {
          if (this.rooms[i].roomId === roomId) {
            room = this.rooms[i];
            break
          }
        }
        if (!room) {
          return
        }
        let selection = [];
        if (room.room_type === "task") {
          // todo query possible users
          let response;
          this.showLoader();
          try {
            response = await this.$http.get(
                Server_URL + '/auftragsbuch/messaging/room/invites/'+room.roomId
            )
          } catch (e) {
            this.hideLoader();
            this.responseError(e)
            return
          }
          this.hideLoader();
          let data = response.body;
          for (let i = 0; i < data.length; i++) {
            let cur = data[i];
            let found = this.isInRoom(room, cur);
            if (!found) {
              let res = JSON.parse(sessionStorage.getItem(cur));
              if (res) {
                selection.push({
                  id: cur,
                  text: res.full_name,
                  node_type: "user",
                  icon: "icon-none",
                  disabled: false,
                  selected: false,
                })
              }
            }
          }
          selection.sort((a,b) => (a.text > b.text) ? 1 : ((b.text > a.text) ? -1 : 0))
        } else {
          selection = this.getCurrentPossibleSelection(this.possibleUser, room)
        }
        this.selectedInvite = null;
        this.possibleInvites = selection;
        this.$refs.invite_modal.showModal();
      } else if(action.name === "leaveChat") {
        let room = null;
        for (let i = 0; i < this.rooms.length; i++) {
          if (this.rooms[i].roomId === roomId) {
            room = this.rooms[i];
            break
          }
        }
        if (!room) {
          return
        }
        await this.leaveChat(roomId, room)
      }
    },
    async leaveChat(roomId, room) {
      let isInChat = false;
      for (let i = 0; i < room.users.length; i++) {
        if (room.users[i]._id === this.myUser) {
          isInChat = true;
          break
        }
      }
      if (!isInChat) {
        this.$bvToast.toast('Sie sind aktuell kein Teilnehmer dieses Chats.', {
          title: 'Verlassen nicht möglich',
          variant: 'warning',
          solid: true,
          toaster: 'b-toaster-bottom-right'
        })
        return
      }
      this.showLoader();
      let me = JSON.parse(sessionStorage.getItem(this.$cookies.get("ps_user_id")));
      let messagePlain = me.full_name + " hat den Chat verlassen."
      let encryptedContent = await encryptAES(sessionStorage.getItem("aes"), messagePlain);
      let req = {
        room_id: roomId,
        message: encryptedContent,
      }
      this.$http.post(
          Server_URL + '/auftragsbuch/messaging/leave_room', req
      ).then(this.onLeaveOk, this.responseError)
    },
    onLeaveOk(response) {
      this.hideLoader();
      if (response.status === 200) {
        this.removeRoom(this.selectedRoom);
      } else {
        window.location = Redirect_500;
      }
    },
    removeRoom(roomId) {
      let roomIndex = this.getRoomIndex(roomId);
      if (roomIndex !== -1) {
        this.rooms.splice(roomIndex, 1);
        this.rooms = [...this.rooms];
      }
      if (this.selectedRoom === roomId) {
        this.selectedRoom = null;
        this.resetMessages();
        this.$nextTick(() => {
          this.roomId = null;
        });
      }
    },
    isInRoom(room, userId) {
      let found = false;
      for (let j = 0; j < room.users.length; j++) {
        if (userId === room.users[j]._id || userId === this.myUser) {
          found = true;
          break
        }
      }
      return found;
    },
    getCurrentPossibleSelection(org, room) {
      let res = [];
      for (let i = 0; i < org.length; i++) {
        let cur = {...org[i]};
        cur.selected = false;
        if (cur.node_type === 'user' && !this.isInRoom(room, cur.id)) {
          res.push(cur)
        } else if(cur.children !== null) {
          cur.children = this.getCurrentPossibleSelection(cur.children, room)
          res.push(cur)
        }
      }
      return res;
    },
    showRoomUsers({ roomId, action }) {
      this.roomUsers = [];
      // get the room =>
      for (let i = 0; i < this.rooms.length; i++) {
        if (this.rooms[i].roomId === roomId) {
          let r = this.rooms[i];
          for (let j = 0; j < r.users.length; j++) {
            if (r.users[j]._id !== 'dummy') {
              let res = JSON.parse(sessionStorage.getItem(r.users[j]._id))
              if (res !== null) {
                this.roomUsers.push(res.full_name);
              }
            }
          }
          break;
        }
      }
      //sort the room users
      this.roomUsers.sort((a, b) => {
        const nameA = a.toUpperCase(); // ignore upper and lowercase
        const nameB = b.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        // names must be equal
        return 0;
      });
      this.showGroup = true;
    },

    async removeMessageInbox(maxAge) {
      let topicId = this.selectedRoom;
      let roomIndex = this.getRoomIndex(this.selectedRoom);
      if (roomIndex === -1) {
        return
      }
      let room = this.rooms[roomIndex];
      let messageType = 4;
      if (room.room_type === "task_int") {
        topicId = topicId.substring(0, topicId.length-9)
        messageType = 5;
      } else if (room.room_type === "chat" || room.room_type === "group" || room.room_type === "forward") {
        messageType = 14
      } else if (room.room_type === "administration") {
        messageType = 13
      }
      let req = {
        topic_id: topicId,
        message_type: messageType,
        max_age: maxAge,
      }
      try {
        await this.$http.post(
            Server_URL + '/auftragsbuch/inbox/delete_by_age', req
        )
      } catch (e) {
        console.log(e);
      }
    },

    async sendMessage({content, roomId, files, replyMessage}) {
      let relisten = false;
      let roomIndex = this.getRoomIndex(roomId);
      if (roomIndex !== -1) {
        if (this.rooms[roomIndex].is_active !== undefined && !this.rooms[roomIndex].is_active) {
          relisten = true;
        }
      }
      let encryptedContent = await encryptAES(sessionStorage.getItem("aes"), content);
      // first insert the message
      let res = JSON.parse(sessionStorage.getItem(this.$cookies.get("ps_user_id")));
      let req = {
        room_id: roomId,
        content: encryptedContent,
        content_plain: content,
        user_name: res.full_name,
      }
      if (files === null) {
        let response;
        try {
          response = await this.$http.post(
              Server_URL + '/auftragsbuch/messaging/message', req
          )
        } catch (e) {
          this.responseError(e)
          return
        }
        if (response.status !== 200) {
          window.location = Redirect_500;
          return
        }
      } else {
        for (let i = 0; i < files.length; i++) {
          files[i].uuid = uuidv4();
          let f = files[i];
          let tempMessage = {
            _id: '',
            indexId: f.uuid,
            content: i === files.length - 1 ? req.content_plain : '',
            senderId: this.currentUserId,
            username: res.full_name,
            timestamp: parseTimestamp(new Date(), 'HH:mm'),
            date: parseTimestamp(new Date(), 'DD MMMM YYYY'),
            saved: true,
            files: [
              {
                name: f.name + (f.extension === "" ? "" : "." + f.extension),
                size: f.size,
                type: f.type,
                audio: false,
                duration: 0.0,
                url: f.localUrl,
                progress: 0,
                uuid: f.uuid,
              }
            ]
          }
          this.messages.push(tempMessage);
        }
        for (let i = 0; i < files.length; i++) {
          let data = new FormData();
          let f = files[i];
          data.set("room_id", roomId);
          data.set("message_id", f.uuid)
          data.set("file_id", f.uuid)
          data.set("user_name", req.user_name)
          if (i === files.length - 1 && req.content_plain !== '') {
            // last message set content
            data.set("content", req.content);
            data.set("contentPlain", req.content_plain);
          } else {
            data.set("contentAutomatic", "true")
            data.set("contentPlain", "Neue Datei: " + f.name + (f.extension === "" ? "" : "." + f.extension))
            let encryptedContent = await encryptAES(sessionStorage.getItem("aes"), "Neue Datei: " + f.name + (f.extension === "" ? "" : "." + f.extension));
            data.set("contentPlain", encryptedContent);
          }
          try {
            if (!isImageFile({type: f.type})) {
              let enc = await encryptFile(sessionStorage.getItem("aes"), await f.blob.arrayBuffer())
              data.set("upload_file", new Blob([enc], {type: f.type}), f.name + (f.extension === "" ? "" : "." + f.extension))
            } else {
              data.set("upload_file", f.blob, f.name + (f.extension === "" ? "" : "." + f.extension))
              data.set("enc_key", sessionStorage.getItem("aes"))
            }
            try {
              let response = await this.$http.post(
                  Server_URL + '/auftragsbuch/messaging/message_file', data, {
                    headers: {
                      'Content-Type': 'multipart/form-data'
                    },
                    progress: (e) => {
                      if (e.lengthComputable && this.selectedRoom === roomId) {
                        let progress = (e.loaded / e.total * 100);
                        for (let j = 0; j < this.messages.length; j++) {
                          if (this.messages[j].indexId === f.uuid) {
                            this.messages[j].files[0].progress = Math.round(progress);
                            this.messages = [...this.messages]
                            break;
                          }
                        }
                      }
                    }
                  }
              )
              if (response.status !== 200) {
                window.location = Redirect_500;
                return
              }
            } catch (r) {
              this.responseError(r)
            }
          }catch (e) {
            console.log(e)
          }
        }
      }
      this.lastActive = new Date();
      if (relisten) {
        roomIndex = this.getRoomIndex(roomId);
        this.rooms[roomIndex].is_active = true;
        this.messagesLoaded = false;
        this.fetchMessages({room: this.rooms[roomIndex]});
      }
    },
    getThumbnailUrl(url, id, fileType) {
      if (!isImageFile({type: fileType})) {
        return ""
      } else {
        let splits = url.split("/")
        splits[splits.length - 1] = id + "_thumb.jpg"
        let res = splits.join("/");
        return res
      }
    },
    onItemClicked(node, item, e) {
      this.selectedUser = this.getSelectedUsers(this.possibleUser);
      this.selectedUserNames = this.getSelectedNames(this.possibleUser);
    },
    handleDataInit(response) {
      if (response.status === 200) {
        let data = response.body;
        console.log(data);
        this.possibleUser = this.setNames(data.possible_users);
        this.myUser = data.user_id;
        if (data.room && data.room.roomId !== "") {
          this.initRoom = data.room;
        }
        this.hideLoader();
        this.fetchRooms();
        this.testModal = true;
      } else {
        this.hideLoader();
        window.location = Redirect_500;
      }
    },
    setNames(org) {
      for (let i = 0; i < org.length; i++) {
        let cur = org[i];
        if (cur.node_type === 'user') {
          let res = JSON.parse(sessionStorage.getItem(cur.id));
          if (res !== null) {
            org[i].text = res.first_name + " " + res.surname;
          }
        }
        if (cur.children !== null && cur.children.length > 0) {
          org[i].children = this.setNames(cur.children);
        }
      }
      return org
    },
    getSelectedUsers(org) {
      let res = [];
      for (let i = 0; i < org.length; i++) {
        let cur = org[i];
        if (cur.node_type === 'user' && cur.selected === true) {
          res.push(cur.id)
        }
        if (cur.children !== null && cur.children.length > 0) {
          res = res.concat(this.getSelectedUsers(cur.children))
        }
      }
      return res;
    },
    getSelectedNames(org) {
      let res = [];
      for (let i = 0; i < org.length; i++) {
        let cur = org[i];
        if (cur.node_type === 'user' && cur.selected === true) {
          res.push(cur.text)
        }
        if (cur.children !== null && cur.children.length > 0) {
          res = res.concat(this.getSelectedNames(cur.children))
        }
      }
      return res;
    },
    unselectUsers(org) {
      for (let i = 0; i < org.length; i++) {
        let cur = org[i];
        if (cur.node_type === 'user' && cur.selected === true) {
          org[i].selected = false;
        }
        if (cur.children !== null && cur.children.length > 0) {
          this.unselectUsers(cur.children)
        }
      }
    },
    onShareMessages({ids, names}) {
      this.selectedUser = ids;
      this.selectedUser.push(this.$cookies.get("ps_user_id"));
      let res = JSON.parse(sessionStorage.getItem(this.$cookies.get("ps_user_id")));
      this.selectedUserNames = names;
      this.selectedUserNames.push(res.full_name);
      this.roomName = "WG von " + res.full_name;
      let messageInitial = res.full_name + " hat eine Nachricht weitergeleitet."
      if (this.shareMessages.length > 1) {
        messageInitial = res.full_name + " hat Nachrichten weitergeleitet."
      }
      encryptAES(sessionStorage.getItem("aes"), messageInitial).then(enc => {
        let req = {
          room_name: this.roomName,
          participants: this.selectedUser,
          participant_names: this.selectedUserNames,
          initial_message: enc,
          forward_room_id: this.shareRoomId,
          forward_message_ids: this.shareMessages
        };
        this.showLoader()
        this.$http.post(
            Server_URL + '/auftragsbuch/messaging/forward', req
        ).then(this.handleRoomOk, this.responseError)
      })
    },
    onCreateRoom({ids, names, room_name}) {
      this.selectedUser = ids;
      this.selectedUser.push(this.$cookies.get("ps_user_id"));
      let res = JSON.parse(sessionStorage.getItem(this.$cookies.get("ps_user_id")));
      this.selectedUserNames = names;
      this.selectedUserNames.push(res.full_name);
      this.roomName = room_name;
      encryptAES(sessionStorage.getItem("aes"), res.full_name + " hat die Gruppe erstellt.").then(enc => {
        let req = {
          room_name: this.roomName,
          participants: this.selectedUser,
          participant_names: this.selectedUserNames,
          initial_message: enc,
        };
        this.showLoader()
        this.$http.post(
            Server_URL + '/auftragsbuch/messaging/room', req
        ).then(this.handleRoomOk, this.responseError)
      })
    },
    handleRoomOk(response) {
      if (response.status === 200) {
        decryptRooms(sessionStorage.getItem("aes"), [response.body]).then(res => {
          this.processRooms(res, true)
          this.hideLoader();
        })
      } else {
        this.hideLoader();
        window.location = Redirect_500;
      }
    },
    handleOkTrap(response) {
      if (response.status === 200) {
        this.hideLoader()
      } else {
        this.hideLoader();
        window.location = Redirect_500;
      }
    },
    onShowCreateRoom() {
     this.$refs.create_chat_modal.showModal();
    },
    onCancelCreateRoom() {
      this.showCreateRoom = false;
    },
    responseError(response) {
      this.hideLoader();
      if (response.status === 401) {
        window.location = Redirect_Login;
      } else {
        window.location = Redirect_Login;
      }
    },
    showLoader() {
      this.hideLoader();
      this.loader = this.$loading.show();
    },
    hideLoader() {
      if (this.loader !== undefined) {
        this.loader.hide();
        this.loader = undefined;
      }
    },
    resetRooms() {
      this.loadingRooms = true;
      this.roomsLoadedCount = 0;
      this.rooms = [];
      this.roomsLoaded = false;
      this.roomListeners.forEach(listener => listener());
      this.roomListeners = [];
      this.resetMessages()
    },
    fetchRooms() {
      this.resetRooms()
      this.fetchMoreRooms(null, true)
    },
    fetchMoreRooms(e, init) {
      if (init) {
        this.listenRooms();
      } else {
        firestoreService.getRooms(this.customerNumber, this.currentUserId, this.roomsPerPage, this.lastLoadedRoom)
            .then(({data, docs}) => {
              let changes = [];
              for (let i = 0; i < data.length; i++) {
                let d = { ...data[i],
                  roomId: data[i].id,
                  doc: docs[i]};
                changes.push(d)
              }
              decryptRooms(sessionStorage.getItem("aes"), changes).then(res => {
                this.processRooms(res)
              })
            })
      }
    },
    listenRooms() {
      const listener = firestoreService.listenRooms(
          this.customerNumber,
          this.myUser,
          this.roomsPerPage,
          (data) => {
            let changes = [];
            let deletions = [];
            for (let i = 0; i < data.length; i++) {
              let d = { ...data[i].doc.data(),
                roomId: data[i].doc.id,
                id: data[i].doc.id,
                doc: data[i].doc};
              if (data[i].type === "removed") {
                deletions.push(d)
              } else {
                changes.push(d)
              }
            }
            for (let i = 0; i < deletions.length; i++) {
              firestoreService.getMessageCounter(this.customerNumber, deletions[i].roomId, this.currentUserId).then((res) => {
                if (!res.last_active) {
                  // user removed from chat
                  this.removeRoom(deletions[i].roomId)
                }
              }).catch(err => {
                console.log(err);
              });
            }
            decryptRooms(sessionStorage.getItem("aes"), changes).then(res => {
              this.processRooms(res, false, true)
            })

          }
      )
      this.roomListeners.push(listener)
    },
    getRoomIndex(roomId) {
      for (let i = 0; i < this.rooms.length; i++) {
        if (this.rooms[i].roomId === roomId) {
          return i;
        }
      }
      return -1;
    },
    async processRooms(data, isNew, fromListener) {
      if (!isNew && !fromListener) {
        this.roomsLoaded = data.length === 0 || data.length < this.roomsPerPage
      }
      let roomId = '';
      if (isNew && data.length === 1) {
        roomId = data[0].roomId;
        let roomIndex = this.getRoomIndex(roomId);
        if (roomIndex !== -1) {
          data[0].oldIndex = this.rooms[roomIndex].index
        }
        this.currentNewId = roomId;
      }
      const roomsToAdd = [];
      for (let i = 0; i < data.length; i++) {
        const room = data[i];
        for (let j = 0; j < room.users.length; j++) {
          let cur = room.users[j];
          let res = JSON.parse(sessionStorage.getItem(cur));
          if (res === null) {
            continue
          }
          let real = {
            _id: cur,
            username: '',
          }
          if (res) {
            real.username = res.full_name;
          }
          room.users[j] = real;
        }
        const roomContacts = room.users.filter(
            user => user._id !== this.currentUserId
        )
        room.users.push({
          _id: "dummy",
          username: ''
        })
        if (room.room_type === "chat") {
          room.roomName =
              roomContacts.map(user => user.username).join(', ')
          room.avatar = "/ic_chat.png"
        } else if (room.room_type === "group") {
          room.avatar = "/ic_group.png"
          room.roomName = room.name;
        } else if (room.room_type === "task") {
          room.avatar = "/ic_task.png"
          room.roomName = room.name;
        } else if (room.room_type === "task_int") {
          room.avatar = "/ic_task_int.png"
          room.roomName = room.name;
        } else if (room.room_type === "forward") {
          room.avatar = "/share.png"
          room.roomName = room.name;
        } else {
          room.avatar = "/ic_admin.png"
          room.roomName = room.name;
        }
        if (room.latest_message) {
          let res = JSON.parse(sessionStorage.getItem(room.latest_message.user_id));
          let lastMessage = {
            content: room.latest_message.content !== "" ? room.latest_message.content : "Datei",
            senderId: room.latest_message.message_type !== "system" ? room.latest_message.user_id : this.myUser,
            username: res && room.latest_message.user_id !== this.myUser && room.latest_message.message_type !== "system" ? res.full_name : '',
            timestamp: isNew ?
                formatTimestamp(
                    new Date(Date.parse(room.latest_message.create_date)),
                    new Date(Date.parse(room.latest_message.create_date))
                ) : formatTimestamp(
                new Date(Date.parse(room.latest_message.create_date.toDate())),
                new Date(Date.parse(room.latest_message.create_date.toDate()))
            )
          }
          room.lastMessage = lastMessage;
        }
        if (isNew) {
          // keep the new room at top until it is re-fetched or the user selects another room
          room.isNew = true;
          room.index = Number.MAX_SAFE_INTEGER;
        } else {
          room.index = room.update_date.toDate().getTime();
        }
        let roomIndex = this.getRoomIndex(room.roomId);
        if (roomIndex !== -1) {
          this.rooms[roomIndex] = room;
          this.rooms = [...this.rooms]
        } else {
          this.rooms.push(room)
          this.rooms = [...this.rooms]
        }
        if (room.is_active === undefined || room.is_active) {
          firestoreService.getMessageCounter(this.customerNumber, room.roomId, this.currentUserId).then(res => {
            let roomIndex = this.getRoomIndex(room.roomId);
            if (roomIndex !== -1) {
              this.rooms[roomIndex].unreadCount = res.count_unread;
              this.rooms = [...this.rooms];
            }
          })
        }
      }

      this.rooms = this.rooms.concat(roomsToAdd)
      if (!this.rooms.length) {
        this.roomsLoadedCount = 0
      } else {
        this.roomsLoadedCount = this.rooms.length
      }
      this.loadingRooms = false
      if (roomId !== '') {
        this.$nextTick(() => {
          this.roomId = roomId;
        });
      }
      if (this.initRoom !== null) {
        this.$nextTick(() => {
          decryptRooms(sessionStorage.getItem("aes"), [this.initRoom]).then(res => {
            this.initRoom = null;
            this.processRooms(res, true)
          })
        });
      }
    },
    resetMessages() {
      // check if we have an empty user chat at top
      for (let i = 0; i < this.rooms.length; i++) {
        if (this.rooms[i].isNew === true && this.rooms[i].roomId !== this.currentNewId) {
          if (this.rooms[i].oldIndex) {
            this.rooms[i].isNew = false;
            this.rooms[i].index = this.rooms[i].oldIndex;
            this.rooms = [...this.rooms]
          } else {
            this.rooms.splice(i, 1);
            this.rooms = [...this.rooms]
          }
          break
        }
      }
      this.currentNewId = '';
      this.messages = [];
      this.messagesLoaded = false;
      this.messageListeners.forEach(listener => listener());
      this.messageListeners = [];
      this.fetchedOnce = false;
      this.lastActive = null;
      this.participants = [];
      this.lastLoadedMessage = null;
      this.latestLoadedMessage = null;
    },
    fetchMessages({room, options = {}}) {
      if (options.reset) {
        this.resetMessages()
        this.roomId = room ? room.roomId : null;
      }
      if (room === undefined) {
        return;
      }
      this.selectedRoom = room.roomId
      if (room.is_active !== undefined && !room.is_active) {
        setTimeout(() => {
          this.messagesLoaded = true
        }, 0)
      } else {
        this.fetchMoreMessages(room);
        this.updateLastReadCounter()
        if (this.lastOnline) {
          this.lastActive = new Date(this.lastOnline.getTime());
        }
      }
    },
    fetchMoreMessages(room) {
      if (!this.fetchedOnce) {
        const listener = firestoreService.listenParticipants(this.customerNumber, room.roomId, data => {
          if (this.selectedRoom !== room.roomId) return;
          this.participants = data;
          if (!this.fetchedOnce) {
            this.fetchedOnce = true;
            this.fetchMoreMessages(room)
          } else {
            this.calculateSeen();
          }
          let roomIndex = this.getRoomIndex(room.roomId);
          if (roomIndex === -1) {
            return;
          }
          //check if we have new users
          for (let i = 0; i < this.participants.length; i++) {
            let p = this.participants[i].id;
            let found = false;
            for (let j = 0; j < this.rooms[roomIndex].users.length; j++) {
              if (p === this.rooms[roomIndex].users[j]._id) {
                found = true;
                break;
              }
            }
            if (!found) {
              this.rooms[roomIndex].users.push({
                username: '',
                _id: p,
              })
              this.rooms = [...this.rooms];
            }
          }
        })
        this.messageListeners.push(listener);
      } else {
        this.selectedRoom = room.roomId
        firestoreService
            .getMessages(this.customerNumber, room.roomId, this.messagesPerPage, this.lastLoadedMessage)
            .then(({data, docs}) => {
              if (this.selectedRoom !== room.roomId) return;
              decryptChatMessages(sessionStorage.getItem("aes"), data).then(res => {
                if (this.selectedRoom !== room.roomId) return;
                if (data.length === 0 || data.length < this.messagesPerPage) {
                  setTimeout(() => {
                    this.messagesLoaded = true
                  }, 0)
                }
                this.processMessages(res, "old")
                if (!this.lastLoadedMessage) {
                  this.latestLoadedMessage = docs[0];
                  this.removeMessageInbox(res[0].create_date.toDate())
                  this.listenMessages(room);
                }
                this.lastLoadedMessage = docs[docs.length - 1]
              })
            })
      }
    },
    listenMessages(room) {
      const listener = firestoreService.listenMessages(
          this.customerNumber,
          room.roomId,
          this.latestLoadedMessage,
          data => {
            if (this.selectedRoom !== room.roomId || !data || data.length === 0) return;
            this.removeMessageInbox(data[0].create_date.toDate())
            decryptChatMessages(sessionStorage.getItem("aes"), data.reverse()).then(res => {
              if (this.selectedRoom !== room.roomId) return;
              this.processMessages(res,  "new")
            })
          }
      )
      this.messageListeners.push(listener)
    },
    getMessageIndex(id, indexId) {
      for (let i = 0; i < this.messages.length; i++) {
        if (this.messages[i]._id === id) {
          return i;
        } else if (indexId !== undefined && indexId !== '' && this.messages[i].indexId === indexId) {
          return i;
        }
      }
      return -1;
    },
    processMessages(data, direction) {
      if (direction !== "new") {
        this.messagesLoaded = data.length === 0 || data.length < this.messagesPerPage;
      }
      let hasNew = false;
      let hasNewSystem = false;
      for (let i = 0; i < data.length; i++) {
        const message = this.formatMessage(data[i]);
        if (!message.system && message.senderId !== this.myUser && direction === 'new') {
          hasNew = true;
        }
        // check if the message already exists, if so update
        let index = this.getMessageIndex(message._id, message.indexId);
        if (index !== -1) {
          this.messages[index] = data[i];
        } else if (direction === 'new') {
          this.messages.push(data[i])
        } else {
          this.messages.unshift(data[i])
        }
      }
      this.messages = [...this.messages]
      if (hasNew) {
        var audioFile = new Audio('/notification.mp3');
        audioFile.play()
        this.updateLastReadCounter()
      }
    },
    updateLastReadCounter() {
      let roomIndex = this.getRoomIndex(this.selectedRoom);
      if (roomIndex !== -1) {
        this.rooms[roomIndex].unreadCount = 0;
        this.rooms = [...this.rooms]
      }
      updateLastRead(this.customerNumber, this.selectedRoom, this.currentUserId)
    },
    calculateSeen() {
      for (let i = 0; i < this.messages.length; i++) {
        let m = this.messages[i];
        if (m.from_id === this.myUser && !m.seen) {
          this.messages[i].seen = this.isMessageSeen(m)
        }
      }
      this.messages = [...this.messages];
    },
    isMessageSeen(m) {
      if (m.seen) {
        return true;
      }
      let seen = true;
      for (let i = 0; i < this.participants.length; i++) {
        let p = this.participants[i];
        if (p.id !== "admin" && p.id !== this.myUser
            && m.create_date.toDate().getTime() > p.last_active.toDate().getTime()) {
          seen = false;
          break;
        }
      }
      return seen;
    },
    formatMessage(message) {
      message._id = message.id;
      message.senderId = message.from_id;
      if (message.from_id !== this.myUser &&
          this.lastActive && this.lastActive.getTime() < message.create_date.toDate().getTime()) {
        message.seen = false;
      } else if (message.from_id !== this.myUser) {
        message.seen = true;
      } else {
        message.seen = this.isMessageSeen(message);
      }
      message.timestamp = parseTimestamp(message.create_date.toDate(), 'HH:mm');
      message.date = parseTimestamp(message.create_date.toDate(), 'DD MMMM YYYY');
      message.distributed = true;
      if (message.value_3 === "system" && message.message_type === 'task') {
        message.system = true;
        let taskShort = JSON.parse(message.value_2);
        console.log(taskShort);
        message.content += ":\\\n**"+taskShort.title+"**\\\n" +
            "**Von:** "+taskShort.from + "\\\n" +
            "**Wo:** "+taskShort.where + "\\\n" +
            "**Ziel:** "+(taskShort.till === "" ? "nicht gesetzt" : taskShort.till) + "\\\n" +
            "[Zur Aufgabe](tasks?task_id=" + taskShort.id + ")"
      } else if (message.value_3 === "system") {
        message.system = true;
      }
      if (message.value_1 !== "") {
        message.indexId = message.value_1;
      }
      if (message.message_type === 'file') {
        message.files = [
          {
            name: message.file_name,
            size: message.file_size,
            type: message.content_type,
            server_url: Server_URL + "/auftragsbuch/" + message.url,
            url: this.getThumbnailUrl(Server_URL + "/auftragsbuch/" + message.url, message.id, message.content_type),
          }
        ]
      } else if (message.message_type === "coordinates") {
        let latRounded = Math.round(message.lat * 10000) / 10000
        let lonRounded = Math.round(message.lon * 10000) / 10000
        message.content = "[Standort: "+latRounded + " " + lonRounded + "](coordinates?lat="+message.lat + "&lon=" + message.lon +")"
      }
      if (message.value_2 === 'prio') {
        message.reactions = {
          "Priorität": [
              "dummy"
          ]
        }
      } else if (message.value_2 === "tb" && message.value_3 === "fin") {
        message.reactions = {
          "✓ Aufgabe": [
            "dummy"
          ]
        }
      } else if (message.value_2 === "tb") {
        message.reactions = {
          "Aufgabe": [
            "dummy"
          ]
        }
      }

      // set username
      let res = JSON.parse(sessionStorage.getItem(message.from_id));
      if (res !== null) {
        message.username = res.first_name + " " + res.surname;
      } else {
        message.username = message.from_name;
        if (message.username === "forward") {
          message.username = "➡ Weitergeleitet"
        }
      }
      return message;
    },
  }
}
</script>

<style>
form-control:disabled, .form-control[disabled] {
  color: black !important;
}

.text-black {
  color: black;
}

.tree-default .tree-disabled > .tree-checkbox {
  display: none;
}

.tree-default .tree-disabled {
  color: inherit !important;
}

</style>

<style scoped>
#vac-circle {
  height: 20px;
  width: 20px;
}

#vac-circle {
  margin: auto;
  height: 28px;
  width: 28px;
  border: 3px rgba(0, 0, 0, .25) solid;
  border-top: 3px #333 solid;
  border-right: 3px #333 solid;
  border-bottom: 3px #333 solid;
  border-radius: 50%;
  -webkit-animation: vac-spin 1s infinite linear;
  animation: vac-spin 1s infinite linear;
}

@keyframes vac-spin {
  from {
    -webkit-transform: rotate(0deg);
    transform: rotate(0);
  }

  to {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}

.my-tree {
  max-height: calc(30vh - 70px);
  overflow: auto;
}

.chat-avatar {
  width: 30px;
  height: 30px;
  line-height: 30px;
  border-radius: 50%;
  font-size: 18px;
  color: rgb(255, 255, 255);
  text-align: center;
  background: rgb(0, 0, 0);
  margin-top: 5px;
  margin-left: 4px;
}

.chat-avatar.mine {
  background: rgb(203, 33, 33);
}

</style>

<style>

.marker {
  background-image: url('../../../public/mangel_marker.png');
  background-size: cover;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 1;
}

.my-body {
  padding: 0 !important;
}

.vac-message-wrapper .vac-message-container {
  width: 90% !important;
}


.vac-message-wrapper .vac-message-box{
  width: 90% !important;
  min-width: 90% !important;
}

.vac-message-wrapper .vac-message-container {
  margin-left: 10% !important;
}
</style>
